import { format } from 'date-fns';
import DataGrid, {
  HeaderFilter,
  Scrolling,
  Column,
  Editing,
  Lookup,
} from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import React, { useCallback, useEffect, useState } from 'react';
import { BoardBody } from '../../components/BoardBody';
import { BoardHeader } from '../../components/BoardHeader';
import master from '../../services/master';
import { Container } from './styles';

interface MethodologiesStore {
  store: CustomStore;
  paginate: boolean;
}

export const Toolkits: React.FC = () => {
  const [toolkits, setToolkits] = useState<DataSource>();
  const [methodologies, setMethodologies] = useState<MethodologiesStore>(
    {} as MethodologiesStore,
  );
  const [toolsDetailId, setToolkitDetailId] = useState();

  const [open, setOpen] = useState(false);

  const loadToolkits = useCallback(async () => {
    const toolkitsStore = new CustomStore({
      key: 'ID',
      loadMode: 'raw',
      load: async () => {
        const { data } = await master.get('/master/toolkits');
        return data.sort((a: any, b: any) => {
          if (a.Name < b.Name) {
            return -1;
          }
          if (a.Name > b.Name) {
            return 1;
          }
          return 0;
        });
      },
      insert: async data => {
        await master.post('/master/toolkits', data);
      },
      update: async (id, data) => {
        await master.put(`/master/toolkits/${id}`, {
          Name: data.Name,
          IsActive: data.IsActive,
        });
      },
    });

    setToolkits(
      new DataSource({
        store: toolkitsStore,
        paginate: true,
        reshapeOnPush: true,
      }),
    );

    setMethodologies({
      store: toolkitsStore,
      paginate: true,
    });
  }, []);

  useEffect(() => {
    loadToolkits();
  }, [loadToolkits]);

  const boldTextCells = useCallback(
    e => (
      <p
        style={{
          color: '#333333',
          fontSize: '14px',
          fontWeight: 'bold',
          whiteSpace: 'break-spaces',
        }}
      >
        {e.text}
      </p>
    ),
    [],
  );

  const entryAtCell = useCallback(
    e => (
      <p
        style={{
          color: '#333333',
          fontSize: '14px',
          fontWeight: 'bold',
          whiteSpace: 'break-spaces',
        }}
      >
        {format(Date.parse(e.text || new Date()), 'MMM. do, yyyy')}
      </p>
    ),
    [],
  );

  return (
    <Container>
      <BoardHeader title="Toolkits" subtitle="Toolkits" />
      <BoardBody>
        <DataGrid
          keyExpr="id"
          dataSource={toolkits}
          onCellClick={e => {
            if (e.rowType === 'data') {
              setToolkitDetailId(e.key);
              setOpen(true);
            }
          }}
        >
          <Editing allowAdding allowUpdating />
          <HeaderFilter visible allowSearch />
          <Scrolling mode="infinite" />
          <Column dataField="Name" cellRender={boldTextCells} />
          <Column
            dataField="CreatedAt"
            allowHeaderFiltering={false}
            allowEditing={false}
            cellRender={entryAtCell}
          />
          <Column dataField="IDMethodology" caption="Methodology">
            <Lookup
              dataSource={methodologies}
              valueExpr="ID"
              displayExpr="Name"
            />
          </Column>

          <Column
            dataField="IsActive"
            allowHeaderFiltering={false}
            dataType="boolean"
            caption="Is Active?"
            cellRender={boldTextCells}
          />
        </DataGrid>
      </BoardBody>
    </Container>
  );
};
